export class AuthConfig {
    checkPhoneAndSendPin: string;
    login: string;
}
